import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTrigger } from "components/app/dialog/dialog";
import DialogUserPermissions from "./DialogUserPermissions";
import { Loader, Settings, X } from "lucide-react";
import { DialogDescription, DialogTitle } from "components/ui/dialog";
import InputHideShow from "components/app/function/InputHideShow";
import { AlertDialogCom } from "components/app/alert-dialog/AlertDialogCom";
import { Button } from "components/ui/button";
import { useState } from "react";
import DialogChangePassword from "pages/setting-and-account/profile-detail/dailog-edit-profile-detail/DialogChangePassword";
import useProfileStore from "store/useProfile";

interface DialogProps {
  user: any;
  isDialogUpdatePageStatus: boolean;
  setIsDialogUpdatePageStatus: (value: boolean) => void;
}

export default function DialogPageSetting({ user, isDialogUpdatePageStatus, setIsDialogUpdatePageStatus }: DialogProps) {
  const [isDialogChangePassword, setIsDialogChangePassword] = useState<boolean>(false);
  const [inputPassword, setInputPassword] = useState<string>("");
  const [validateText, setValidateText] = useState<string>("");
  const [loadingUpdatePageStatus, setLoadingUpdatePageStatus] = useState<boolean>(false);
  const [isDialogUpdatePageStatusDelete, setIsDialogUpdatePageStatusDelete] = useState<boolean>(false);

  const { onSubmitUnpublishToPublished, onSubmitPublishedToUnpublish, onSubmitDeletePage } = useProfileStore();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Settings className="p-1 bg-gray-50 dark:bg-accent dark:hover:bg-slate-900 w-9 h-9 rounded-full border cursor-pointer" />
      </DialogTrigger>
      <DialogContent isShowBtnXClose={true} className="custom-dialog-class">
        <DialogHeader>
          <DialogTitle>Page Setting</DialogTitle>
          <DialogDescription>The Page Settings section allows you to manage the visibility, access, and status of your pages.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col space-y-2">
          {user?.status === "Unpublished" && (
            <Dialog open={isDialogUpdatePageStatus}>
              <DialogTrigger
                asChild
                onClick={() => {
                  if (user.provider_set_password === "No") {
                    setIsDialogChangePassword(true);
                  } else {
                    // setInputPassword("");
                    // setValidateText("");
                    setIsDialogUpdatePageStatus(true);
                  }
                }}
                className="rounded-lg p-2 w-full bg-sky-600 hover:bg-sky-500 flex items-center justify-center"
              >
                <button className="font-semibold text-xs text-white">Publish</button>
              </DialogTrigger>

              <DialogContent isShowBtnXClose={false} className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>Publish Page</DialogTitle>
                  <DialogDescription>You are sending your Page informatin to our review team, the review process will take 24 hours!</DialogDescription>
                  <div
                    className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
                    onClick={() => setIsDialogUpdatePageStatus(false)}
                  >
                    <X />
                  </div>
                </DialogHeader>
                <div>
                  <p>Please input your password for confirmation</p>
                  <div className="mt-2">
                    <InputHideShow onChange={(event) => setInputPassword(event.target.value)} placeholder="Password" />
                    <span className="text-sm text-destructive">{validateText}</span>
                  </div>
                </div>
                <DialogFooter className="sm:justify-end">
                  <AlertDialogCom
                    alertTitle="Confirmation"
                    handleSubmit={() =>
                      onSubmitUnpublishToPublished({
                        inputPassword: inputPassword,
                        setIsDialogUpdatePageStatus: setIsDialogUpdatePageStatus,
                        setLoadingUpdatePageStatus: setLoadingUpdatePageStatus,
                        setValidateText: setValidateText,
                      })
                    }
                    nameSubmitButton="Ok"
                    alertDescription="Do you want to continue?"
                  >
                    <Button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300">
                      {loadingUpdatePageStatus ? <Loader className="animate-spin w-5 h-5" /> : "Continue"}
                    </Button>
                  </AlertDialogCom>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}

          {["In Review", "Actived"].includes(user.status) && (
            <Dialog open={isDialogUpdatePageStatus}>
              <DialogTrigger
                onClick={() => {
                  setInputPassword("");
                  setValidateText("");
                  setIsDialogUpdatePageStatus(true);
                }}
                asChild
                className="rounded-lg p-2 w-full bg-destructive hover:bg-red-600 flex items-center justify-center"
              >
                <button className="font-semibold text-xs text-white">Unpublished</button>
              </DialogTrigger>
              <DialogContent isShowBtnXClose={false} className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>Unpublished Page</DialogTitle>
                  <DialogDescription>This page is currently published and visible to users. If you want to unpublish your page, you can click on 'Unpublished'.</DialogDescription>
                  <div
                    className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
                    onClick={() => setIsDialogUpdatePageStatus(false)}
                  >
                    <X />
                  </div>
                </DialogHeader>
                <div>
                  <p>Please input your password for confirmation</p>
                  <div className="mt-2">
                    <InputHideShow onChange={(event) => setInputPassword(event.target.value)} placeholder="Password" />
                    <span className="text-sm text-destructive">{validateText}</span>
                  </div>
                </div>
                <DialogFooter className="sm:justify-end">
                  <AlertDialogCom
                    alertTitle="Confirmation"
                    handleSubmit={() =>
                      onSubmitPublishedToUnpublish({
                        inputPassword: inputPassword,
                        setIsDialogUpdatePageStatus: setIsDialogUpdatePageStatus,
                        setLoadingUpdatePageStatus: setLoadingUpdatePageStatus,
                        setValidateText: setValidateText,
                      })
                    }
                    nameSubmitButton="Ok"
                    alertDescription="Do you want to continue?"
                  >
                    <Button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300">
                      {loadingUpdatePageStatus ? <Loader className="animate-spin w-5 h-5" /> : "Continue"}
                    </Button>
                  </AlertDialogCom>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}

          {user?.status === "Unpublished" && (
            <Dialog open={isDialogUpdatePageStatusDelete}>
              <DialogTrigger
                onClick={() => {
                  setInputPassword("");
                  setValidateText("");
                  setIsDialogUpdatePageStatusDelete(true);
                }}
                asChild
                className="rounded-lg p-2 w-full bg-red-500 hover:bg-red-400 flex items-center justify-center"
              >
                <button className="font-semibold text-xs text-white">Delete Page</button>
              </DialogTrigger>

              <DialogContent isShowBtnXClose={false} className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>Delete Page</DialogTitle>
                  <DialogDescription>
                    You are deleting your page information, you have only 30 days to recover you page back, otherwise, your page data will be deleted!
                  </DialogDescription>
                  <div
                    className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
                    onClick={() => setIsDialogUpdatePageStatusDelete(false)}
                  >
                    <X />
                  </div>
                </DialogHeader>
                <div>
                  <p>Please input your password for confirmation</p>
                  <div className="mt-2">
                    <InputHideShow onChange={(event) => setInputPassword(event.target.value)} placeholder="Password" />
                    <span className="text-sm text-destructive">{validateText}</span>
                  </div>
                </div>
                <DialogFooter className="sm:justify-end">
                  <AlertDialogCom
                    alertTitle="Are you sure?"
                    alertDescription="This action cannot be undone. Are you sure you want to proceed?"
                    handleSubmit={() =>
                      onSubmitDeletePage({
                        inputPassword: inputPassword,
                        setIsDialogUpdatePageStatus: setIsDialogUpdatePageStatus,
                        setLoadingUpdatePageStatus: setLoadingUpdatePageStatus,
                        setValidateText: setValidateText,
                      })
                    }
                    nameSubmitButton="Confirm"
                    loading={loadingUpdatePageStatus}
                  >
                    <Button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300">
                      {loadingUpdatePageStatus ? <Loader className="animate-spin w-5 h-5" /> : "Continue"}
                    </Button>
                  </AlertDialogCom>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}

          {/* User Permissions */}
          <DialogUserPermissions user={user} />

          <DialogChangePassword
            userProfileDetail={user}
            setUserProfileDetail={(value) => {
              useProfileStore.setState({ user: value });
            }}
            isDialogOpen={isDialogChangePassword}
            setIsDialogOpen={setIsDialogChangePassword}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
